// window.onbeforeunload = function (e) {
//     if (window.session!= undefined && window.session.get('status') == 100) {
//         window.utils.clearSessionStorage();
//         window.utils.clearUserSettingsLocalStorage();
//     }
// };
//

window.debug= true;

// window.onerror = function(errorMsg, url, lineNumber, col, error) {
//     if(window.location.href.indexOf(".relpro.") > -1 ) {
//         if(window.user != undefined && window.user.has('id')){
//             Raven.setUserContext({
//                 id: window.user.get('id')
//             });
//         }
//         if(window.location.href.indexOf("app.relpro.") == -1 ) {
//             Raven.showReportDialog();
//         }
//     } else {
//         if( typeof console != undefined){
//             console.error(error);
//             alert(error);
//         }
//     }
// };

require.onError = function (err) {
    throw err;
};

require.config({
    urlArgs: "version=" + (new Date()).getTime(),
    paths: {
        jquery          : 'libs/jquery/jquery',
        jqueryUi        : 'libs/jquery/jquery-ui.min',
        semantic        : 'libs/jquery/semantic.min',
        datePicker      : 'libs/bootstrap/bootstrap.datepicker',
        json2           : 'libs/json2/json2',
        card            : 'libs/card/jquery.card',
        underscore      : 'libs/underscore/underscore',
        backbone        : 'libs/backbone/backbone',
        bootstrap       : 'libs/bootstrap/bootstrap.min',
        bootstrapSwitch : 'libs/bootstrap/bootstrap-switch.min',
        marionette      : 'libs/marionette/backbone.marionette.min',
        moment          : 'libs/moment/moment',
        momentTZ        : 'libs/moment/moment-timezone',
        text            : 'libs/underscore/text',
        tpl             : 'libs/underscore/underscore-tpl',
        select2         : 'libs/select2/select2',
        snackBar        : 'libs/snackbar/snackbar.min',
        underscorestring: 'libs/underscorestring/underscore.string.min',
        nouislider      : 'libs/noUiSlider/nouislider.min',
        // glue            : 'libs/tick42-glue/Tick42CRM',
        he              : 'libs/he/he'
    },
    shim: {
        'backbone': {
            deps: ['underscore', 'jquery'],
            exports: 'Backbone'
        },
        'jquery': {
            exports: '$'
        },
        'bootstrap': {
            deps: ['jquery'],
            exports: '$'
        },
        card: {
            deps: ['jquery'],
            exports: '$'
        },
        'underscore': {
            exports: '_'
        },
        'underscorestring': {
            exports: '_S'
        },
        select2:{
            deps: ['jquery']
        },
        snackBar:{
            deps: ['jquery']
        },
        bootstrapSwitch:{
            deps: ['jquery'],
            exports: '$'
        },
        jqueryUi:{
            deps: ['jquery'],
            exports: '$'
        },
        semantic:{
            deps: ['jquery'],
            exports: '$'
        }
    }
});require([
    'client'
], function(App){
    App.start();
});



define("main", function(){});

